module.exports = __webpack_public_path__ + "static/media/logo-kpmgdv.37347b95.png";